'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["menuItems"];
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import PropTypes from 'prop-types';
import { Component } from 'react';
import withDisabledContext from '../hoc/withDisabledContext';
import { MultiLevelDropdown } from 'foundations-components/transitional/components/Dropdown';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ToolbarMenu extends Component {
  constructor(...args) {
    super(...args);
    this.getOptionForMenuItem = menuItem => {
      let {
        child
      } = menuItem;
      if (!child) {
        return this.renderMenuItem(menuItem);
      }
      if (typeof child === 'function') {
        child = child();
      }
      return {
        label: menuItem.text,
        options: [child],
        icon: menuItem.Icon,
        'data-test-id': menuItem.name
      };
    };
  }
  renderMenuItem({
    name,
    onClick,
    text,
    render,
    disabled,
    tooltip,
    Icon
  }) {
    if (typeof render === 'function') {
      return render({
        key: name
      });
    }
    const MenuButton = /*#__PURE__*/_jsxs(Button, {
      disabled: disabled,
      "data-test-id": name,
      onClick: onClick,
      children: [Icon && /*#__PURE__*/_jsx(Icon, {
        alignWithText: "true"
      }), text]
    }, name);
    if (typeof tooltip === 'object') {
      const {
        title,
        placement = 'bottom'
      } = tooltip;
      return /*#__PURE__*/_jsx(Tooltip, {
        title: title,
        placement: placement,
        children: MenuButton
      });
    }
    return MenuButton;
  }
  render() {
    const _this$props = this.props,
      {
        menuItems
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(MultiLevelDropdown, Object.assign({
      buttonUse: "transparent",
      buttonSize: "small",
      placement: "bottom",
      arrowSize: "small",
      animateOnToggle: false,
      options: menuItems.map(this.getOptionForMenuItem)
    }, rest));
  }
}
ToolbarMenu.propTypes = {
  menuItems: PropTypes.array.isRequired
};
export default withDisabledContext(ToolbarMenu);